module.exports = __webpack_public_path__ + "static/media/20200921_171526.95447cf6.jpg";